export const CreateDataTableObject= (headers) => {
    return {
    headers: headers,
    loading: false,
    items: [],
    pagination: {
        totalItems: 0,
        page: 1,
        itemsPerPage: 5,
    },
    }
};

export const SetDataTableResponse = (data, res) => {
    data.items = res.data;
    data.pagination.totalItems = res.total_data;
    data.pagination.itemsPerPage = res.total_per_page;
    data.pagination.page = res.current_page;
    return data;
}